export default {
  accessToken: null,
  activeCharityId: null,
  adminInfo: null
}
